module.exports = __webpack_public_path__ + "img/lock.png?5b748e3b417f2bd33322398998c23f09";